import Endpoints from '@/config/ApiEndpoints.js';	
import Axios from 'axios';
import $ from 'jquery'; 
import VueGallery from "vue-gallery";
var moment = require("moment");
export default {
	props:['VehicleId'],
	components:{
		VueGallery		
	},
	filters: {
        date: function(data) {
        	var sendDate = "N/A";
			if (data != "" && data != null) {
			sendDate = moment(data).format("DD-MM-YYYY");
			}
			return sendDate;
        }
    },
	data() {
		return {
			settings4: {
				maxScrollbarLength: 60,
				suppressScrollY: true,
			},
			CheckFailures: [],
			
			ShowVehicleNotesModel: false,
			ShowVehicleNotesModelHeading: "Notes",
			ShowVehicleCheckImageModel: false,
			lightgallery: [],
			biglightgallery: [],
			gindex: 1,
			galleryoptions: {
			  prevClass: "prev",
			  nextClass: "next",
			},
			ShowMardAsFixedModel: false,
			MardAsFixedModelHeading: '',
			Event:{},
			SubmitEvent:{},
		}
	},		
	mounted() {		
		this.GetVehicleCheckFailure();	
		this.initSubmitEventObject();	
	},
	
	methods : { 
	  GetVehicleCheckFailure() {
			if(this.VehicleId > 0){
				Axios.post(Endpoints.Vehicle.CheckFailure, {
				token: localStorage.getItem("token"),
				vehicle_id: this.VehicleId,
				}).then((Response) => {
				if (Response.data.success) {
					this.CheckFailures = Response.data.VehicleCheckFailure;
				}
				});
			}
	  },
	  ShowVehicleNotes(VehicleCheck, type = "notes") {
		if (VehicleCheck.notes != null && VehicleCheck.notes != "") {
		  this.ShowVehicleNotesModel = true;
		  this.VehicleNotes = VehicleCheck.notes;
		  this.ShowVehicleNotesModelHeading = "Notes";
		}
	  },
	  MarkAsFixedOld(checkFailures) {
		this.$swal
		  .fire({
			title:
			  "Are you sure You want to Mark this Vehicle Check Failures & Issues as Fixed?",
			text: "You won't be able to revert this!",
			icon: "warning",
			showCancelButton: true,
			confirmButtonText: "Yes",
			reverseButtons: true,
		  })
		  .then((result) => {
			if (result.isConfirmed) {
			  this.$swal.fire({
				title: "Deleting...",
				text: "Please wait...",
				showConfirmButton: false,
				allowOutsideClick: false,
			  });
			  Axios.post(Endpoints.Vehicle.FixCheckFailure, {
				token: localStorage.getItem("token"),
				fleet_check_submit_value_id: checkFailures.id,
				fleet_check_submit_id: checkFailures.check_submit_id,
			  }).then((Response) => {
				if (Response.data.success == true) {
				  this.$swal.close();
				  this.GetVehicleCheckFailure();
				  this.$swal
					.fire(
					  "Vehicle Check Failures & Issues Marked as Fixed Successfully",
					  "",
					  "success"
					)
					.then(() => {});
				} else {
				  this.$swal
					.fire("Error:" + Response.data.message, "", "error")
					.then(() => {});
				}
			  });
			}
		  });
	  },	  
      ShowVehicleImage(VehicleCheck) {
        this.ShowVehicleCheckImageModel = true;
        this.lightgallery = JSON.parse(VehicleCheck.photo);
        this.biglightgallery = JSON.parse(VehicleCheck.photo);
        for (var i = 0; i < this.biglightgallery.length; i++) {
          this.biglightgallery[i] =
          Endpoints.Helper.Image + "/" + this.biglightgallery[i];
        }
      },
      initSubmitEventObject(){
  		var user= JSON.parse(localStorage.getItem('User'));  		
  		this.SubmitEvent = {
	  		action:0,
	      	date_fixed:'',
	      	notes:'',
	      	confirm:false,
	      	licence_category:'',
	      	licence_number:'',
	      	licence_expiry_date:'',
	      	cpc_expiry_date:'',
	      	adr_expiry_date:'',
	      	mot_appointment_date:'',
	      	mot_passed:'',
	      	service_booked_date:'',
	      	serviced_date:'',
	      	next_service_date:'',
	      	serviced_due_month:'1 Year',
	      	serviced_due_miles:'10000',
	      	serviced_due_soonest:'1',
	      	sorn:false,
	      	tax_auto_renew:false,
	      	tax_renew_date:'',
	      	action_username:user.forename+' '+user.surname,
	      	insurance_auto_renew:false,
	      	insurance_renew_date:'',
	      	service_document:'',
	      	service_document_name:'',
      	}
      }, 
      MarkAsFixed(event){      	
        this.ShowMardAsFixedModel=true;        
        console.log('event',event);
        this.Event=event;
        if(event.type=='vehiclecheck' && event.status=='yellow'){
          this.MardAsFixedModelHeading = 'Vehicle Check Warning Action';
        }
        if(event.type=='vehiclecheck' && event.status=='red'){
          this.MardAsFixedModelHeading = 'Vehicle Check Failure Action';
        }        
      },
      MarkAsFixedSubmit(){
    	console.log('event',this.Event);
    	console.log('SubmitEvent',this.SubmitEvent);
    	var error = false;
		var errorStr = '';		
    	
    	/* check error for vehicle check*/
    	if(this.Event.type=='vehiclecheck'){
    		if (this.SubmitEvent.action < 1) {
				error = true;
				errorStr += '<li>Please Select Action</li>';
			}
			if (this.SubmitEvent.action ==1 && this.SubmitEvent.date_fixed == "") {
				error = true;
				errorStr += '<li>Please Select Date Fixed</li>';
			}
			if (this.SubmitEvent.action == 3 && !this.SubmitEvent.confirm) {
				error = true;
				errorStr += '<li>Please Confirm Clear warning without addressing</li>';
			}
    	}

    	if (error == true) {
			this.$swal('Following Error Found!', errorStr, 'error').then(() => {});
		}else{
			this.$swal({
			  title: 'Updating Event...',
			  text: 'Please wait...',
			  imageUrl: require('@/assets/images/LoadingTwo.gif'),
			  showConfirmButton: false,
			  allowOutsideClick: false,
			});
			Axios.post(Endpoints.Dashboard.UpcomingEventSubmit,{
        		token: localStorage.getItem("token"),
        		Event: this.Event,
        		SubmitEvent: this.SubmitEvent,        		
      		}).then( (Response) => {      			
		    	if (Response.data.success == true) {
		      		this.ShowMardAsFixedModel = false;	
		      		this.GetVehicleCheckFailure();	      		
		      		this.initSubmitEventObject();	      		
		      		this.$swal('Event Updated Successfully','','success').then(() => {});
		    	} else {
		      		this.$swal(Response.data.message, '', 'error').then(() => {});
		    	}	
			});
		}

      }
	},
	
}